import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * BalanceFloorBanner · quiet banner that lights when the Universal Key well
 * drops below 20% of its starting balance. Public surface — everyone sees the
 * alarm state but not the raw balance.
 *
 * Founder ruling 2026-08-11:
 *   "Balance Floor Alarm — Wire a 20% Universal Key balance alarm to email
 *    or banner the Founder before the Anthropic well runs dry."
 */
export default function BalanceFloorBanner() {
  const [state, setState] = useState(null);

  useEffect(() => {
    let mounted = true;
    const load = () => {
      fetch(`${API}/api/sage/balance/status`)
        .then((r) => r.json())
        .then((d) => { if (mounted) setState(d); })
        .catch(() => {});
    };
    load();
    const t = setInterval(load, 60_000); // refresh every 60s
    return () => { mounted = false; clearInterval(t); };
  }, []);

  if (!state?.alarm_lit) return null;

  return (
    <div
      data-testid="balance-floor-banner"
      className="bg-sage-warn text-sage-bg px-4 py-2 text-center text-xs uppercase tracking-[0.2em] font-bold border-b-2 border-sage-warn"
    >
      Model fuel well is drying · {Math.round((state.fraction_remaining || 0) * 100)}% remaining · top up before it runs dry
    </div>
  );
}
